import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from "../../contexts/auth";
import { documentiList } from "../../services/api_dipendenti";
import { Link } from "wouter";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";

import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

import { Popover } from "@headlessui/react";
import moment from "moment";
import Empty from "../../components/empty";
import Fetching from "../../components/fetching";
import Footer from "../../components/footer";

import ArFirme from "./firme";

export default function ArDocuments() {
  const { token } = useContext(AuthContext);
  /* TAB PRINCIPALE */
  const [selectedTab, setSelectedTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);

    return params.get("tab") === "firmati" ? "firmati" : "caricati";
  });
  /* DOCUMENTI NORMALI */
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* CARICAMENTO DOCUMENTI NORMALI */
  useEffect(() => {
    if (!token) return;

    let active = true;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await documentiList(token);

        if (!active) return;
        setDocs(Array.isArray(response) ? response : []);
        setError(null);
      } catch (err) {
        if (!active) return;
        console.error("Errore caricamento documenti:", err);
        setError("Impossibile caricare i documenti.");
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      active = false;
    };
  }, [token]);

  return (
    <div className="flex min-h-screen flex-col">
      <div className="mb-8 flex-grow">
        {/* INTESTAZIONE PAGINA */}
        <Popover as="header" className="bg-indigo-200">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex justify-center py-4">
              <h2 className="text-center text-2xl font-semibold text-indigo-800">
                I miei documenti
              </h2>
            </div>
          </div>
        </Popover>

        <main className="mx-auto mt-8 max-w-7xl px-4 pb-10 sm:px-6 lg:px-8">
          {/* CARD GESTIONE DOCUMENTI */}
          <div className="overflow-visible rounded-xl border border-gray-300 bg-white">
            {/* INTESTAZIONE E TOGGLE */}
            <div className="flex flex-col gap-4 p-4 sm:p-5 lg:flex-row lg:items-center lg:justify-between">
              <div className="min-w-0">
                <h3 className="text-base font-semibold uppercase text-indigo-800">
                  I miei documenti
                </h3>
                <p className="mt-1 text-xs text-gray-500">
                  Consulta i documenti caricati dall'azienda e quelli che richiedono la tua firma elettronica
                </p>
              </div>

              {/* TOGGLE TIPO DOCUMENTO */}
              <div className="grid w-full grid-cols-1 overflow-hidden rounded-lg shadow-sm sm:grid-cols-2 lg:w-auto lg:min-w-[440px]">
                {/* CARICATI */}
                <button
                  type="button"
                  onClick={() => setSelectedTab("caricati")}
                  className={`relative flex min-w-0 items-center justify-center gap-2 border px-4 py-3 text-xs font-semibold transition sm:rounded-l-lg sm:text-sm ${
                    selectedTab === "caricati"
                      ? "z-10 border-indigo-300 bg-indigo-100 text-indigo-800"
                      : "border-gray-200 bg-gray-50 text-gray-500 hover:bg-gray-100"
                  }`}
                >
                  <UploadFileOutlinedIcon sx={{ fontSize: 20 }} className="shrink-0" />
                  <span className="truncate">Ricevuti</span>
                </button>

                {/* CON FIRMA */}
                <button
                  type="button"
                  onClick={() => setSelectedTab("firmati")}
                  className={`relative flex min-w-0 items-center justify-center gap-2 border px-4 py-3 text-xs font-semibold transition sm:rounded-r-lg sm:text-sm ${
                    selectedTab === "firmati"
                      ? "z-10 border-indigo-300 bg-indigo-100 text-indigo-800"
                      : "border-gray-200 bg-gray-50 text-gray-500 hover:bg-gray-100"
                  }`}
                >
                  <DrawOutlinedIcon sx={{ fontSize: 20 }} className="shrink-0" />
                  <span className="truncate">Con Firma</span>
                </button>
              </div>
            </div>
          </div>

          {/* CONTENUTO TAB */}
          <div className="pt-6">
            {selectedTab === "caricati" ? (
              /* DOCUMENTI NORMALI */
              <div className="w-full">
                {/* CARICAMENTO */}
                {loading ? (
                  <Fetching />
                ) : error ? (
                  <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-600">
                    {error}
                  </div>
                ) : docs.length === 0 ? (
                  <Empty />
                ) : (
                  /* TABELLA DOCUMENTI */
                  <div className="max-h-[100vh] overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-sm">
                    <table className="min-w-full table-fixed">
                      <colgroup>
                        <col className="w-[35%]" />
                        <col className="w-[25%]" />
                        <col className="w-[15%]" />
                        <col className="w-[15%]" />
                        <col className="w-[10%]" />
                      </colgroup>
                      {/* INTESTAZIONE TABELLA */}
                      <thead className="sticky top-0 z-10 bg-indigo-50 border-b border-gray-200">
                        <tr>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-indigo-800 sm:pl-6">
                              Nome
                            </th>
                            <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-indigo-800 sm:table-cell">
                              Descrizione
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-indigo-800">
                              Stato lettura
                            </th>
                            <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-indigo-800 sm:table-cell">
                              Caricato il
                            </th>
                            <th scope="col" className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-indigo-800 sm:pr-6">
                              Azioni
                            </th>
                        </tr>
                      </thead>

                      {/* CORPO TABELLA */}
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {docs.map(c => (
                          <tr key={c.id} className="hover:bg-gray-50">
                            {/* NOME */}
                            <td className="py-4 pl-4 pr-3 align-top text-sm sm:pl-6">
                              <div className="break-words font-medium text-gray-900">
                                {c.nome}
                              </div>
                            </td>

                            {/* DESCRIZIONE */}
                            <td className="hidden break-words px-3 py-3.5 align-top text-sm text-gray-500 sm:table-cell">
                              {c.descrizione || "—"}
                            </td>

                            {/* STATO LETTURA */}
                            <td className="whitespace-nowrap px-3 py-3.5 text-center align-top text-sm text-gray-500">
                              {c?.status === "read" ? (
                                <CheckCircleIcon className="mr-1 inline-block h-5 w-5 text-teal-500" />
                              ) : (
                                <XCircleIcon className="mr-1 inline-block h-5 w-5 text-red-500" />
                              )}
                            </td>

                            {/* CARICATO IL */}
                            <td className="hidden whitespace-nowrap px-3 py-3.5 align-top text-sm text-gray-500 sm:table-cell">
                              <time dateTime={c.created_at}>{moment(c.created_at).format("DD/MM/YYYY HH:mm")}</time>
                            </td>

                            {/* AZIONI */}
                            <td className="whitespace-nowrap py-3.5 pl-3 pr-4 text-right align-top text-sm font-medium sm:pr-6">
                              <Link
                                to={`/areariservata/documenti/${c.id}`}
                                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition hover:bg-gray-50"
                              >
                                Leggi
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ) : (
              /* DOCUMENTI CON FIRMA */
              <div className="w-full">
                <ArFirme embedded />
              </div>
            )}
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}